import React from 'react'
import { Row, Col } from 'antd'
import LocationInfoMarkerLongdoMap from '../Marker/LocationInfoMarkerLongdoMap'

const LocationIconMarker = ({ title, lat, lng, type, key }) =>
  type === 'Plant' ? (
    <Row>
      <Col span={24}>
        {title !== '' && (
          <div
            style={{
              zIndex: -2,
              width: '160px',
              padding: '7px 15px 7px 15px',
              display: 'inline-flex',
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              transform: 'translate(-50%, -180%)',
              color: '#fff',
              backgroundColor: '#051734',
              position: 'relative',
              left: 0,
              top: 80,
              bottom: 0,
              minHeight: '35px',
              border: '2px solid #051734',
              fontSize: 11,
              marginLeft: '15px',
              borderRadius: '15px',
            }}
          >
            <img
              src="/img/pngmarker/Group 18585.png"
              alt="CPAC_icon"
              style={{
                zIndex: -2,
                marginRight: 10,
              }}
            />
            <span>{title}</span>
            <div
              style={{
                position: 'absolute',
                left: 70,
                bottom: -15,
                zIndex: -2,
                width: 0,
                height: 0,
                borderLeft: '7px solid transparent',
                borderRight: '7px solid transparent',
                borderTop: '12px solid #051734',
                marginLeft: '15px',
              }}
            />
          </div>
        )}
      </Col>
    </Row>
  ) : type === 'Plant' ? (
    <Row>
      <Col span={24}>
        {title !== '' && (
          <div
            style={{
              zIndex: -2,
              width: '160px',
              padding: '7px 15px 7px 15px',
              display: 'inline-flex',
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              transform: 'translate(-50%, -180%)',
              color: '#fff',
              backgroundColor: '#051734',
              position: 'relative',
              left: 0,
              top: 80,
              bottom: 0,
              minHeight: '35px',
              border: '2px solid #051734',
              fontSize: 11,
              marginLeft: '15px',
              borderRadius: '15px',
            }}
          >
            <img
              src="/img/Qmixpng.png"
              alt="Qmix_icon"
              style={{
                zIndex: -2,
                marginRight: 10,
              }}
            />
            <span>{title}</span>
            <div
              style={{
                position: 'absolute',
                left: 70,
                bottom: -15,
                zIndex: -2,
                width: 0,
                height: 0,
                borderLeft: '7px solid transparent',
                borderRight: '7px solid transparent',
                borderTop: '12px solid #051734',
                marginLeft: '15px',
              }}
            />
          </div>
        )}
      </Col>
    </Row>
  ) : type === 'Site' ? (
    <Row>
      <Col span={24}>
        {title !== '' && (
          <div
            style={{
              zIndex: -2,
              width: '160px',
              padding: '7px 15px 7px 15px',
              display: 'inline-flex',
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              transform: 'translate(-50%, -180%)',
              color: '#fff',
              backgroundColor: '#051734',
              position: 'relative',
              left: 0,
              top: 80,
              bottom: 0,
              minHeight: '35px',
              border: '2px solid #051734',
              fontSize: 11,
              marginLeft: '15px',
              borderRadius: '15px',
            }}
          >
            <img
              src="/img/pngmarker/Group993.png"
              alt="Site_icon"
              style={{
                zIndex: -2,
                marginRight: 10,
              }}
            />
            <span>{title}</span>
            <div
              style={{
                position: 'absolute',
                left: 70,
                bottom: -15,
                zIndex: -2,
                width: 0,
                height: 0,
                borderLeft: '7px solid transparent',
                borderRight: '7px solid transparent',
                borderTop: '12px solid #051734',
                marginLeft: '15px',
              }}
            />
          </div>
        )}
      </Col>
    </Row>
  ) : (
    <>
      <LocationInfoMarkerLongdoMap
        title={title}
        key={key}
        lat={lat}
        lng={lng}
      />
    </>
  )

export default LocationIconMarker
